export default __webpack_public_path__ + "static/media/vip-2.dbcd4e18.webp";